export const title = 'Conclusão dos pedidos';

Proporção dos pedidos feitos pelo app que foram concluídos (pagos) em relação aos que não foram concluídos.

Um pedido não concluído é aquele que foi criado, mas não chegou a ser pago. Isso inclui pagamentos pendentes
(como boleto ou Pix ainda não pagos), pagamentos recusados e pedidos cancelados.
